
import axios from '../../helpers/axios';


// export const updatedProduct = (id, updateOrder) => axios.patch(`/order/update/${id}`, updateOrder)
export const deletedOrder = (id) => axios.delete(`/order/delete/${id}`)
